import React, { useEffect, useState } from 'react'
import './C.css';
import axios from 'axios';
import {useNavigate } from 'react-router-dom';
import { useUser } from './UserProvider';
import PremiumPopup from './PremiumPopup';
import KalIndicator from './KalIndicator';
import PaymentFailure from './PaymentFailure';
import { useLocation } from 'react-router-dom';
import SuccessAnimation from './SuccessAnimation';


const UserProfile = () => {
   const navigate = useNavigate();
  const { userDetails, setUserDetails } = useUser();
  const [loading, setLoading] = useState(true);
  const [showPremiumPopup, setShowPremiumPopup] = useState(false);
  const [errMess, setErrMess] = useState("");
  const [currentStep, setCurrentStep] = useState("");
  const location = useLocation();
  useEffect(() => {
    // שליפת פרמטרים מה-URL
    const queryParams = new URLSearchParams(location.search);
    const responseCode = queryParams.get('ResponseCode');
    // console.log("sd")
    // אם יש קוד שגיאה, נעבד את השגיאה
    if (responseCode) {

      const errorMessage = getErrorMessage(responseCode);
      setErrMess(errorMessage);
      setCurrentStep("error")

      // אם יש שגיאה, נשלח את המשתמש לדף כישלון
      // if (responseCode === "60000004") {
      //   setTimeout(() => {
      //     history.push('/payment-failure'); // דף כישלון בתשלום
      //   }, 3000); // מחכים 3 שניות לפני המעבר לדף אחר
      // }
    }
  }, []); // מתעדכן אם ה-URL משתנה

  // פונקציה שמחזירה הודעת שגיאה לפי ה-ResponseCode
  const getErrorMessage = (responseCode) => {
    switch (responseCode) {
      case "60000001":
        return "הכרטיס חסום לשימוש.";
      case "60000002":
        return "הכרטיס לא תקף.";
      case "60000003":
        return "עסקה לא אושרה על ידי הבנק.";
      case "60000004":
        return "פרטי כרטיס שגויים.";
      case "60000005":
        return "הכרטיס לא תואם לעסקה.";
      case "60000006":
        return "חיבור לרשת לא זמין.";
      case "60000007":
        return "זמן עסקה עבר.";
      case "60000008":
        return "מסגרת אשראי לא מספיקה.";
      default:
        return "שגיאה לא ידועה. אנא נסה שוב.";
    }
  };




  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await axios.get("dashboard/member/member_self");

        const avatar = res.data?.imgFacePicture
          ? `https://archivebureau.s3.eu-west-3.amazonaws.com/${res.data.imgFacePicture}?t=${Date.now()}`
          : "";

        const details = {
          userName: `${res.data.firstName} ${res.data.lastName}`,
          avatarUrl: avatar,
          activeDues: res.data?.activeDues,
          activeAdvocacy: res.data?.activeAdvocacy
        };

        setUserDetails(details);

        // הצגת פופ-אפ פעם אחת
        if (!details.activeDues && !localStorage.getItem("premium_popup_shown")) {
          setShowPremiumPopup(true);
          localStorage.setItem("premium_popup_shown", "true");
        }

      } finally {
        setLoading(false);
      }
    };

    fetchUser();
  }, [currentStep === "success"]);
  const handleAvatarClick = () => {
    if (!userDetails?.activeDues) {
      // פותח פופאפ
      setShowPremiumPopup(true);

      // כשהפופאפ נסגר → מעבר לדף
      // return;
    }

    // אם יש קל"ה → דלג ישר לדף
    navigate("PapeUserDetails");
  };

  // const handlePopupClose = () => {
  //   setShowPremiumPopup(false);
  //   navigate("/PapeUserDetails"); // מעבר אחרי סגירת הפופ־אפ
  // };

  const defaultAvatar = "https://placehold.co/200";

  // SKELETON לטעינה
  if (loading) {
    return (
      <div className="user-profile flex items-center justify-between gap-3 px-4 animate-pulse">
        <div className="w-12 h-12 rounded-full bg-gray-300"></div>
        <div className="w-12 h-3 bg-gray-300 rounded"></div>
        <div className="w-12 h-12 rounded-full bg-gray-300"></div>
      </div>
    );
  }

  return (
    <>
      <PremiumPopup show={showPremiumPopup} onClose={() => setShowPremiumPopup(false)} onNext={(ErrMess) => {
        setCurrentStep("success")
        setErrMess(ErrMess)
        setShowPremiumPopup(false)
      }
      }
        onError={(ErrMess) => {
          setCurrentStep("error")
          setErrMess(ErrMess)
          setShowPremiumPopup(false)
        }}
      />
      {(currentStep === "error") && <PaymentFailure onClose={() => setCurrentStep("")} error={errMess} titlerror={"התשלום נכשל"} />}
      {(currentStep === "success") && <SuccessAnimation onNext={() => setCurrentStep("")} titlerror={errMess} />}

      <div  className="user-profile justify-between  ">
        <div className='flex items-center'>
          <img
            src={userDetails?.avatarUrl || defaultAvatar}
            alt="Avatar"
            className={`avatar ring-2 ${userDetails?.activeDues ? 'ring-[#04ec2b]' : 'ring-[#ff3636]'}`}
          onClick={handleAvatarClick}
          />

          <div className="user-name">שלום, {userDetails?.userName}</div>
        </div>
        <KalIndicator hasRecurringPayment={userDetails?.activeAdvocacy} />
      </div>
    </>
  );
};
export default UserProfile